import repository from '@/utils/repository';

export default {
    searchMst002Info: (data) => {
        return repository.post('/move/postCommonMst002Info', {
            ...data
        });
    }
};
